import React from 'react';

import {
  Button,

  CardHeader,
  FormGroup,
  Row,
  Form,
  
} from 'reactstrap';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";

import {columnsForSAP, columns,endusercolumns,customStyles } from "variables/tablecoulmns";

import ModalForm from '../modal/modal'
import AuthService from "services/auth.service";

import Timestamp from "react-timestamp";
import Loader from "react-loader-spinner";


import "./styles.css";
import AgentTform from '../TicketForms/Tktviewform'
import UserTform from '../TicketForms/EndUser-ViewTktform'




//const viewQuery ="SELECT ID,name,class FROM school ";
 class DTable extends React.Component {
   
    constructor(props) {
        super(props);
        const Currentuser = AuthService.getCurrentUser();
        const CurrentUserAcc=Currentuser.username 
        const currentuserfname=Currentuser.userfullname 

        const UserRoles = Currentuser.roles;

        const isAgent = UserRoles.includes('ROLE_AGENT');

      



        this.state = {
            viewdata:[
              {
                  "id": 22534,
                  "agent": "test.user",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to perform the daily health check \n   for Site1 site datacenter and update \"Site1\" Excel sheet\n   on the below link:\n     then please update on this ticket with any technical issues if exist or just comment with \"All Ok\" if not.",
                  "queue": "Systems",
                  "category": "DataCenter",
                  "sub": "Daily Health Check",
                  "state": "Completed",
                  "slares": "Achieved",
                  "actsla": "Achieved",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site1",
                  "resolution": "true",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-28T08:00:00.000Z",
                  "updatedAt": "2022-02-28T08:18:58.000Z"
              },

              {
                  "id": 22497,
                  "agent": "test.user",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to perform the daily health check \n   for Site1 site datacenter and update \"Site1\" Excel sheet\n   on the below link:\n     then please update on this ticket with any technical issues if exist or just comment with \"All Ok\" if not.",
                  "queue": "Systems",
                  "category": "DataCenter",
                  "sub": "Daily Health Check",
                  "state": "Completed",
                  "slares": "Achieved",
                  "actsla": "Achieved",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site1",
                  "resolution": "true",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-23T08:00:00.000Z",
                  "updatedAt": "2022-02-23T10:16:12.000Z"
              },

              {
                  "id": 22488,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to perform the daily health check \n   for Site1 site datacenter and update \"Site1\" Excel sheet\n   on the below link:\n     then please update on this ticket with any technical issues if exist or just comment with \"All Ok\" if not.",
                  "queue": "Systems",
                  "category": "DataCenter",
                  "sub": "Daily Health Check",
                  "state": "Completed",
                  "slares": "Achieved",
                  "actsla": "Achieved",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site1",
                  "resolution": "true",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-22T08:00:00.000Z",
                  "updatedAt": "2022-02-22T08:15:54.000Z"
              },
              {
                  "id": 22477,
                  "agent": "test.user",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to perform the daily health check \n   for Site1 site datacenter and update \"Site1\" Excel sheet\n   on the below link:\n     then please update on this ticket with any technical issues if exist or just comment with \"All Ok\" if not.",
                  "queue": "Systems",
                  "category": "DataCenter",
                  "sub": "Daily Health Check",
                  "state": "Closed",
                  "slares": "Achieved",
                  "actsla": "Achieved",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site1",
                  "resolution": "true",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-21T08:00:00.000Z",
                  "updatedAt": "2022-02-21T09:07:22.000Z"
              },
              {
                  "id": 22465,
                  "agent": "test.user",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to perform the daily health check \n   for Site1 site datacenter and update \"Site1\" Excel sheet\n   on the below link:\n     then please update on this ticket with any technical issues if exist or just comment with \"All Ok\" if not.",
                  "queue": "Systems",
                  "category": "DataCenter",
                  "sub": "Daily Health Check",
                  "state": "Closed",
                  "slares": "Achieved",
                  "actsla": "Achieved",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site1",
                  "resolution": "true",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-20T08:00:00.000Z",
                  "updatedAt": "2022-02-20T08:14:15.000Z"
              },
              {
                  "id": 22442,
                  "agent": "test.user",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to perform the daily health check \n   for Site1 site datacenter and update \"Site1\" Excel sheet\n   on the below link:\n     then please update on this ticket with any technical issues if exist or just comment with \"All Ok\" if not.",
                  "queue": "Systems",
                  "category": "DataCenter",
                  "sub": "Daily Health Check",
                  "state": "Closed",
                  "slares": "Achieved",
                  "actsla": "Achieved",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site1",
                  "resolution": "true",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-16T08:00:00.000Z",
                  "updatedAt": "2022-02-16T08:46:36.000Z"
              },
              {
                  "id": 22437,
                  "agent": "test.user",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to perform the daily health check \n   for Site1 site datacenter and update \"Site1\" Excel sheet\n   on the below link:\n     then please update on this ticket with any technical issues if exist or just comment with \"All Ok\" if not.",
                  "queue": "Systems",
                  "category": "DataCenter",
                  "sub": "Daily Health Check",
                  "state": "Closed",
                  "slares": "Violated",
                  "actsla": "Achieved",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site1",
                  "resolution": "false",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-15T08:00:00.000Z",
                  "updatedAt": "2022-02-16T08:46:52.000Z"
              }
          ],
            loading:false,
            selectedRows: [],
            isOpen: false,
            targetid:'',
            user:CurrentUserAcc,
            userfullname:currentuserfname,
            isAgent:isAgent,
            UserRoles:UserRoles,
            isomits:window.innerWidth <= 1600 

        };

      }




 componentDidMount() {

}

componentWillUnmount(){

}






 
 handleButtonClick = (state) => {
    //alert('action Clicked for Row Number'+ state.target.id);
    this.setState({ isOpen: true , targetid: state.target.id});
  };
  handleChange = state => {
    console.log('state', state.selectedRows);

    this.setState({ selectedRows: state.selectedRows });
  };





  handleFilterChange = (e) =>{ 
  

    let Filterpromise = new Promise((myResolve, myReject) =>{ 
    
    // The producing code (this may take some time)
    this.setState({[e.target.name]: e.target.value})
  
  
  
  
        myResolve(e.target.name);
        myReject("Error");
      
  
  
  
  
    });
    
    Filterpromise.then(
      (value)  =>{console.log(value);},
      (error)  =>{}
    );
    
    
    
  
  //handleChange = (e) =>{ this.setState({[e.target.name]: e.target.value})
  
  
  }





  openModal = () => this.setState({ isOpen: true });
  closeModal = () => {this.setState({ isOpen: false ,targetid:''});}


  render(){
    let data = this.state.viewdata
    const tableData = {
      columns,
      data
    };
let ConditionalTktView = this.state.isAgent ? <AgentTform tktid={this.state.targetid}></AgentTform> :<UserTform tktid={this.state.targetid}></UserTform> ;

let coulmstoview = this.state.UserRoles.includes('ROLE_SAP') ? columnsForSAP(this.handleButtonClick ,this.state.isomits) :
 columns(this.handleButtonClick ,this.state.isomits);
this.state.UserRoles.length < 1 ?  coulmstoview = endusercolumns(this.handleButtonClick) :
 coulmstoview = columns(this.handleButtonClick,this.state.isomits)


  return (
<div>
{ this.state.loading ? 
  <Row className="justify-content-center align-items-center" >

<Loader
        type="Puff"
        color="rgb(101, 153, 57)"
        height={150}
        width={150}
        timeout={15000} //3 secs
      /></Row>
:
<div>
<CardHeader>
    {this.state.isAgent ?  <h5 className="title">Tickets Assigned To Agent {this.state.userfullname}</h5> :
    <h5 className="title">{this.props.tktstates} Tickets For User {this.state.userfullname}</h5>

 }
              
              

                </CardHeader>

<Form>

      <FormGroup>
        <Row>







          </Row>
</FormGroup>
</Form>












      <DataTableExtensions columns={coulmstoview}  data={data} exportHeaders print={false} filterPlaceholder="Search">


                <DataTable

                data={this.state.viewdata}
                
                columns={coulmstoview}
                onRowSelected={this.handleChange}
              customStyles={customStyles}
                //  style={{maxWidth:'500px'}}
                pagination
                paginationPerPage={20}
                paginationRowsPerPageOptions={[10, 20, 50, 100  ]	}
                selectableRows
                responsive
                highlightOnHover
                noHeader = {this.state.isomits}

                striped

                />
                      </DataTableExtensions>
                      </div>
}
        { this.state.isOpen ? 
          <ModalForm 
            closeModal={this.closeModal} 
            isOpen={this.state.isOpen} 
            title={"Ticket# " + this.state.targetid}
            hoste={ConditionalTktView}
            size="lg"
          /> 
          : 
          null 
        }





        

</div>

  );
}
}
export default DTable;
